import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@babackapp/ui/components/sidebar";
import useIsMobile from "@babackapp/ui/lib/use-is-mobile";
import {
  ADMIN_SCREEN_LINKS,
  ScreenLinksProvider,
} from "@/shared-screens/screen-links";
import { Navigate, Outlet } from "react-router-dom";
import { AdminSidebar } from "./admin-sidebar";

/**
 * Layout guard for the /admin section.
 * Only accessible to users with services.superpowers.activated = true and MFA
 * enabled (BAB-3035).
 *
 * Kept free of any shop context (no useCurrentShop) so the section can be
 * lifted into its own app (BAB-3310).
 */
export default function AdminLayout() {
  const isSuperAdmin = useViewerIsSuperAdmin();
  const isMobile = useIsMobile();

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset className="min-w-0 flex-1">
        <div className="h-full min-w-0">
          {isMobile && <SidebarTrigger />}
          {/* Shared screens link inside the admin, never to Returns. */}
          <ScreenLinksProvider links={ADMIN_SCREEN_LINKS}>
            <Outlet />
          </ScreenLinksProvider>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
